// extracted by mini-css-extract-plugin
module.exports = {"settings":"Settings_settings__2Bs6v","header":"Settings_header__3AJXI","back":"Settings_back__1LGXd","logout":"Settings_logout__3x2zp"};